import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, Teleport as _Teleport, createBlock as _createBlock, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "fm-root" }
const _hoisted_2 = { class: "fm-toolbar" }
const _hoisted_3 = { class: "fm-breadcrumb" }
const _hoisted_4 = { class: "fm-crumb fm-crumb-active" }
const _hoisted_5 = { class: "fm-toolbar-actions" }
const _hoisted_6 = { class: "fm-count" }
const _hoisted_7 = {
  key: 0,
  class: "fm-selection-bar"
}
const _hoisted_8 = { class: "fm-selection-count" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "fm-create-folder"
}
const _hoisted_13 = {
  key: 0,
  class: "fm-upload-panel"
}
const _hoisted_14 = { class: "fm-panel-inner" }
const _hoisted_15 = { class: "fm-panel-header" }
const _hoisted_16 = { class: "fm-drop-icon" }
const _hoisted_17 = { class: "fm-drop-label" }
const _hoisted_18 = { class: "fm-form-row" }
const _hoisted_19 = { class: "fm-field" }
const _hoisted_20 = { class: "fm-field fm-field-xs" }
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "fm-field" }
const _hoisted_23 = {
  key: 0,
  class: "fm-field fm-field-xs"
}
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "fm-panel-footer" }
const _hoisted_26 = { class: "fm-panel-btns" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 1,
  class: "fm-error"
}
const _hoisted_29 = {
  key: 0,
  class: "fm-empty"
}
const _hoisted_30 = { class: "fm-empty-icon" }
const _hoisted_31 = {
  key: 1,
  class: "fm-grid"
}
const _hoisted_32 = ["onClick", "onDragover", "onDragleave", "onDrop"]
const _hoisted_33 = { class: "fm-card-info" }
const _hoisted_34 = ["title"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["draggable", "onClick", "onDragstart"]
const _hoisted_38 = ["checked", "onChange"]
const _hoisted_39 = { class: "fm-card-thumb" }
const _hoisted_40 = ["src"]
const _hoisted_41 = { class: "fm-icon-ext" }
const _hoisted_42 = { class: "fm-card-info" }
const _hoisted_43 = ["title"]
const _hoisted_44 = { class: "fm-card-meta" }
const _hoisted_45 = { class: "fm-badge-rev" }
const _hoisted_46 = { class: "fm-card-type" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = ["onClick"]
const _hoisted_49 = {
  key: 0,
  class: "fm-upload-panel fm-edit-panel"
}
const _hoisted_50 = { class: "fm-panel-inner" }
const _hoisted_51 = { class: "fm-panel-header" }
const _hoisted_52 = { class: "fm-panel-title" }
const _hoisted_53 = { class: "fm-drop-icon" }
const _hoisted_54 = { class: "fm-drop-label" }
const _hoisted_55 = { class: "fm-form-row" }
const _hoisted_56 = { class: "fm-field" }
const _hoisted_57 = { class: "fm-field fm-field-xs" }
const _hoisted_58 = ["value"]
const _hoisted_59 = { class: "fm-field" }
const _hoisted_60 = {
  key: 0,
  class: "fm-field fm-field-xs"
}
const _hoisted_61 = ["value"]
const _hoisted_62 = { class: "fm-panel-footer" }
const _hoisted_63 = { class: "fm-panel-btns" }
const _hoisted_64 = {
  key: 1,
  class: "fm-error"
}
const _hoisted_65 = { class: "fm-rename-modal" }
const _hoisted_66 = { class: "fm-panel-header" }
const _hoisted_67 = {
  class: "fm-panel-btns",
  style: {"margin-top":"12px"}
}
const _hoisted_68 = { class: "fm-rename-modal" }
const _hoisted_69 = { class: "fm-panel-header" }
const _hoisted_70 = { class: "fm-panel-title" }
const _hoisted_71 = { class: "fm-field" }
const _hoisted_72 = ["value"]
const _hoisted_73 = {
  class: "fm-panel-btns",
  style: {"margin-top":"12px"}
}
const _hoisted_74 = ["disabled"]
const _hoisted_75 = { class: "fm-rename-modal" }
const _hoisted_76 = { class: "fm-panel-header" }
const _hoisted_77 = {
  class: "fm-panel-btns",
  style: {"margin-top":"12px"}
}
const _hoisted_78 = ["disabled"]
const _hoisted_79 = { class: "fm-viewer-modal" }
const _hoisted_80 = { class: "fm-viewer-header" }
const _hoisted_81 = { class: "fm-viewer-title-group" }
const _hoisted_82 = { class: "fm-icon-ext" }
const _hoisted_83 = { class: "fm-viewer-name" }
const _hoisted_84 = { class: "fm-viewer-meta" }
const _hoisted_85 = { class: "fm-viewer-controls" }
const _hoisted_86 = { class: "fm-viewer-body" }
const _hoisted_87 = ["src"]
const _hoisted_88 = {
  key: 1,
  class: "fm-dwg-placeholder"
}
const _hoisted_89 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmDeleteModal = _resolveComponent("ConfirmDeleteModal")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: _normalizeClass(["fm-crumb", { 'fm-crumb-active': !_ctx.currentFolderId, 'fm-crumb-drop': _ctx.dragOverRoot }]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exitFolder && _ctx.exitFolder(...args))),
          onDragover: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onRootDragOver && _ctx.onRootDragOver(...args)), ["prevent"])),
          onDragleave: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onRootDragLeave && _ctx.onRootDragLeave(...args)), ["prevent"])),
          onDrop: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onRootDrop && _ctx.onRootDrop(...args)), ["prevent"]))
        }, " Arquivos ", 34),
        (_ctx.currentFolder)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[67] || (_cache[67] = _createElementVNode("span", { class: "fm-crumb-sep" }, "›", -1)),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.currentFolder.name), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.visibleFiles.length) + " arquivo" + _toDisplayString(_ctx.visibleFiles.length !== 1 ? 's' : ''), 1),
        (_ctx.accessMode === 'edit' && _ctx.hasSelectedFiles)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.selectedFiles.length) + " selecionado" + _toDisplayString(_ctx.selectedFiles.length !== 1 ? 's' : ''), 1),
              _createElementVNode("button", {
                class: "fm-btn fm-btn-ghost fm-btn-sm",
                type: "button",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.selectAllVisibleFiles && _ctx.selectAllVisibleFiles(...args)))
              }, "Marcar visÃ­veis"),
              _createElementVNode("button", {
                class: "fm-btn fm-btn-ghost fm-btn-sm",
                type: "button",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openMoveModal && _ctx.openMoveModal(...args)))
              }, "Mover"),
              _createElementVNode("button", {
                class: "fm-btn fm-btn-ghost fm-btn-sm",
                type: "button",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.duplicateSelectedFiles && _ctx.duplicateSelectedFiles(...args))),
                disabled: _ctx.bulkActionLoading
              }, "Duplicar", 8, _hoisted_9),
              _createElementVNode("button", {
                class: "fm-btn fm-btn-ghost fm-btn-sm",
                type: "button",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.openRenameSelected && _ctx.openRenameSelected(...args))),
                disabled: _ctx.selectedFiles.length !== 1
              }, "Renomear", 8, _hoisted_10),
              _createElementVNode("button", {
                class: "fm-btn fm-btn-danger fm-btn-sm",
                type: "button",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.askDeleteSelected && _ctx.askDeleteSelected(...args))),
                disabled: _ctx.bulkActionLoading
              }, "Apagar", 8, _hoisted_11),
              _createElementVNode("button", {
                class: "fm-btn fm-btn-ghost fm-btn-sm",
                type: "button",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.clearSelection && _ctx.clearSelection(...args)))
              }, "Limpar")
            ]))
          : _createCommentVNode("", true),
        (_ctx.accessMode === 'edit')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("button", {
                class: "fm-btn fm-btn-ghost fm-btn-sm",
                type: "button",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.startCreateFolder && _ctx.startCreateFolder(...args)))
              }, " + Pasta "),
              _createElementVNode("button", {
                class: "fm-btn fm-btn-primary fm-btn-sm",
                type: "button",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.toggleUploadPanel && _ctx.toggleUploadPanel(...args)))
              }, " + Arquivo ")
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_Transition, { name: "slide-down" }, {
      default: _withCtx(() => [
        (_ctx.creatingFolder)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _withDirectives(_createElementVNode("input", {
                ref: "folderInputRef",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.newFolderName) = $event)),
                class: "fm-folder-input",
                type: "text",
                placeholder: "Nome da pasta",
                onKeydown: [
                  _cache[13] || (_cache[13] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submitCreateFolder && _ctx.submitCreateFolder(...args)), ["enter"])),
                  _cache[14] || (_cache[14] = _withKeys(($event: any) => (_ctx.creatingFolder = false), ["esc"]))
                ]
              }, null, 544), [
                [_vModelText, _ctx.newFolderName]
              ]),
              _createElementVNode("button", {
                class: "fm-btn fm-btn-primary fm-btn-sm",
                type: "button",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.submitCreateFolder && _ctx.submitCreateFolder(...args)))
              }, "Criar"),
              _createElementVNode("button", {
                class: "fm-btn fm-btn-ghost fm-btn-sm",
                type: "button",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.creatingFolder = false))
              }, "Cancelar")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "slide-down" }, {
      default: _withCtx(() => [
        (_ctx.showCreateForm)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _cache[68] || (_cache[68] = _createElementVNode("span", { class: "fm-panel-title" }, "Adicionar arquivo(s)", -1)),
                  _createElementVNode("button", {
                    class: "fm-close-btn",
                    type: "button",
                    onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.toggleCreateForm && _ctx.toggleCreateForm(...args)))
                  }, "✕")
                ]),
                _createElementVNode("form", {
                  onSubmit: _cache[29] || (_cache[29] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitCreate && _ctx.submitCreate(...args)), ["prevent"]))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["fm-drop-zone", { 'fm-drop-zone--has-file': _ctx.createForm.selectedFileName }]),
                    onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.triggerNewFile && _ctx.triggerNewFile(...args))),
                    onDragover: _cache[20] || (_cache[20] = _withModifiers(() => {}, ["prevent"])),
                    onDrop: _cache[21] || (_cache[21] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDropFile && _ctx.onDropFile(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("input", {
                      ref: "newFileInputRef",
                      type: "file",
                      accept: ".pdf,.dwg,image/*",
                      class: "hidden-input",
                      onChange: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.onNewFilePicked && _ctx.onNewFilePicked(...args)))
                    }, null, 544),
                    _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.createForm.selectedFileName ? '✔' : '↑'), 1),
                    _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.createForm.selectedFileName || 'Clique ou arraste um arquivo'), 1),
                    _cache[69] || (_cache[69] = _createElementVNode("div", { class: "fm-drop-hint" }, "PDF, DWG ou imagem", -1))
                  ], 34),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _cache[70] || (_cache[70] = _createElementVNode("label", null, "Nome no sistema", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.createForm.customName) = $event)),
                        type: "text",
                        placeholder: "Ex: Planta baixa R0"
                      }, null, 512), [
                        [_vModelText, _ctx.createForm.customName]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _cache[71] || (_cache[71] = _createElementVNode("label", null, "Revisão", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.createForm.revision) = $event))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.revisionOptions, (r) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: r,
                            value: r
                          }, _toDisplayString(r), 9, _hoisted_21))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.createForm.revision]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _cache[72] || (_cache[72] = _createElementVNode("label", null, "Descrição", -1)),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.createForm.description) = $event)),
                      rows: "2",
                      placeholder: "Opcional"
                    }, null, 512), [
                      [_vModelText, _ctx.createForm.description]
                    ])
                  ]),
                  (_ctx.folders.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _cache[74] || (_cache[74] = _createElementVNode("label", null, "Pasta", -1)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.createForm.folderId) = $event))
                        }, [
                          _cache[73] || (_cache[73] = _createElementVNode("option", { value: "" }, "Raiz", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folders, (f) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: f.id,
                              value: f.id
                            }, _toDisplayString(f.name), 9, _hoisted_24))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.createForm.folderId]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("button", {
                      class: "fm-btn fm-btn-ghost fm-btn-sm",
                      type: "button",
                      onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.triggerMultipleFiles && _ctx.triggerMultipleFiles(...args)))
                    }, [
                      _createElementVNode("input", {
                        ref: "multiFileInputRef",
                        type: "file",
                        accept: ".pdf,.dwg,image/*",
                        multiple: "",
                        class: "hidden-input",
                        onChange: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.onMultipleFilesPicked && _ctx.onMultipleFilesPicked(...args)))
                      }, null, 544),
                      _createTextVNode(" Múltiplos arquivos" + _toDisplayString(_ctx.multiFiles.length > 0 ? ` (${_ctx.multiFiles.length})` : ''), 1)
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("button", {
                        class: "fm-btn fm-btn-ghost fm-btn-sm",
                        type: "button",
                        onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.toggleCreateForm && _ctx.toggleCreateForm(...args)))
                      }, "Cancelar"),
                      _createElementVNode("button", {
                        class: "fm-btn fm-btn-primary fm-btn-sm",
                        type: "submit",
                        disabled: _ctx.uploading
                      }, _toDisplayString(_ctx.uploading ? 'Enviando…' : 'Enviar'), 9, _hoisted_27)
                    ])
                  ]),
                  (_ctx.formError)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(_ctx.formError), 1))
                    : _createCommentVNode("", true)
                ], 32)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.gridItems.length === 0 && !_ctx.showCreateForm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.currentFolderId ? '📂' : '📁'), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.currentFolderId ? 'Esta pasta está vazia.' : 'Nenhum arquivo ainda.'), 1),
          (_ctx.accessMode === 'edit' && !_ctx.currentFolderId)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "fm-btn fm-btn-primary fm-btn-sm",
                type: "button",
                onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.toggleUploadPanel && _ctx.toggleUploadPanel(...args)))
              }, " Adicionar arquivo "))
            : _createCommentVNode("", true)
        ]))
      : (_ctx.gridItems.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleFolders, (folder) => {
              return (_openBlock(), _createElementBlock("div", {
                key: 'f-' + folder.id,
                class: _normalizeClass(["fm-card fm-card--folder", { 'fm-card--drag-over': _ctx.dragOverFolderId === folder.id }]),
                onClick: ($event: any) => (_ctx.enterFolder(folder)),
                onDragover: _withModifiers(($event: any) => (_ctx.onFolderDragOver(folder)), ["prevent"]),
                onDragleave: _withModifiers(($event: any) => (_ctx.onFolderDragLeave(folder)), ["prevent"]),
                onDrop: _withModifiers(($event: any) => (_ctx.onFolderDrop(folder)), ["prevent"])
              }, [
                _cache[78] || (_cache[78] = _createStaticVNode("<div class=\"fm-card-thumb fm-thumb-folder\" data-v-6e036b2c><svg width=\"38\" height=\"30\" viewBox=\"0 0 38 30\" fill=\"none\" data-v-6e036b2c><rect x=\"0\" y=\"6\" width=\"38\" height=\"24\" rx=\"3\" fill=\"currentColor\" opacity=\"0.25\" data-v-6e036b2c></rect><rect x=\"0\" y=\"3\" width=\"16\" height=\"6\" rx=\"2\" fill=\"currentColor\" opacity=\"0.4\" data-v-6e036b2c></rect><rect x=\"0\" y=\"6\" width=\"38\" height=\"24\" rx=\"3\" fill=\"currentColor\" opacity=\"0.15\" data-v-6e036b2c></rect></svg></div>", 1)),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", {
                    class: "fm-card-name",
                    title: folder.name
                  }, _toDisplayString(folder.name), 9, _hoisted_34),
                  _cache[75] || (_cache[75] = _createElementVNode("div", { class: "fm-card-meta" }, [
                    _createElementVNode("span", { class: "fm-card-type" }, "Pasta")
                  ], -1))
                ]),
                (_ctx.accessMode === 'edit')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "fm-card-hover",
                      onClick: _cache[31] || (_cache[31] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createElementVNode("button", {
                        class: "fm-action-btn",
                        title: "Renomear",
                        onClick: ($event: any) => (_ctx.openRenameFolder(folder))
                      }, [...(_cache[76] || (_cache[76] = [
                        _createElementVNode("svg", {
                          width: "14",
                          height: "14",
                          viewBox: "0 0 16 16",
                          fill: "none"
                        }, [
                          _createElementVNode("path", {
                            d: "M11.5 2.5a1.5 1.5 0 012 2L5 13H3v-2L11.5 2.5z",
                            stroke: "currentColor",
                            "stroke-width": "1.3",
                            fill: "none"
                          })
                        ], -1)
                      ]))], 8, _hoisted_35),
                      _createElementVNode("button", {
                        class: "fm-action-btn fm-action-danger",
                        title: "Excluir",
                        onClick: ($event: any) => (_ctx.askDeleteFolder(folder))
                      }, [...(_cache[77] || (_cache[77] = [
                        _createElementVNode("svg", {
                          width: "14",
                          height: "14",
                          viewBox: "0 0 16 16",
                          fill: "none"
                        }, [
                          _createElementVNode("path", {
                            d: "M3 4h10M6 4V2h4v2M5 4v9a1 1 0 001 1h4a1 1 0 001-1V4H5z",
                            stroke: "currentColor",
                            "stroke-width": "1.3",
                            fill: "none"
                          })
                        ], -1)
                      ]))], 8, _hoisted_36)
                    ]))
                  : _createCommentVNode("", true)
              ], 42, _hoisted_32))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleFiles, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: 'file-' + item.id,
                class: _normalizeClass(["fm-card fm-card--file", { 'fm-card--selected': _ctx.isFileSelected(item.id), 'fm-card--dragging': _ctx.draggingFileIds.includes(item.id) }]),
                draggable: _ctx.accessMode === 'edit',
                onClick: ($event: any) => (_ctx.openViewer(item)),
                onDragstart: ($event: any) => (_ctx.onFileDragStart(item, $event)),
                onDragend: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.onFileDragEnd && _ctx.onFileDragEnd(...args)))
              }, [
                (_ctx.accessMode === 'edit')
                  ? (_openBlock(), _createElementBlock("label", {
                      key: 0,
                      class: _normalizeClass(["fm-select-check", { 'fm-select-check--checked': _ctx.isFileSelected(item.id) }]),
                      onClick: _cache[32] || (_cache[32] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        checked: _ctx.isFileSelected(item.id),
                        onChange: ($event: any) => (_ctx.toggleFileSelection(item.id))
                      }, null, 40, _hoisted_38),
                      _cache[79] || (_cache[79] = _createElementVNode("span", null, null, -1))
                    ], 2))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_39, [
                  (item.thumbnailBase64)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "fm-thumb-img",
                        src: item.thumbnailBase64.startsWith('/uploads/') ? _ctx.$resolveUrl(item.thumbnailBase64) : `data:image/jpeg;base64,${item.thumbnailBase64}`,
                        alt: ""
                      }, null, 8, _hoisted_40))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["fm-file-icon", `fm-icon-${item.extension.toLowerCase()}`])
                      }, [
                        _createElementVNode("span", _hoisted_41, _toDisplayString(item.extension.toUpperCase()), 1)
                      ], 2))
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", {
                    class: "fm-card-name",
                    title: item.name
                  }, _toDisplayString(item.name), 9, _hoisted_43),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("span", _hoisted_45, _toDisplayString(item.revision || 'R0'), 1),
                    _createElementVNode("span", _hoisted_46, _toDisplayString(item.extension.toUpperCase()), 1)
                  ])
                ]),
                _createElementVNode("div", {
                  class: "fm-card-hover",
                  onClick: _cache[33] || (_cache[33] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("button", {
                    class: "fm-action-btn",
                    title: "Visualizar",
                    onClick: ($event: any) => (_ctx.openViewer(item))
                  }, [...(_cache[80] || (_cache[80] = [
                    _createElementVNode("svg", {
                      width: "14",
                      height: "14",
                      viewBox: "0 0 16 16",
                      fill: "none"
                    }, [
                      _createElementVNode("path", {
                        d: "M8 3C4.5 3 1.5 8 1.5 8s3 5 6.5 5 6.5-5 6.5-5-3-5-6.5-5zm0 8a3 3 0 110-6 3 3 0 010 6z",
                        fill: "currentColor"
                      }),
                      _createElementVNode("circle", {
                        cx: "8",
                        cy: "8",
                        r: "1.5",
                        fill: "currentColor"
                      })
                    ], -1)
                  ]))], 8, _hoisted_47),
                  (_ctx.accessMode === 'edit')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "fm-action-btn",
                        title: "Editar",
                        onClick: ($event: any) => (_ctx.openEditForm(item.id))
                      }, [...(_cache[81] || (_cache[81] = [
                        _createElementVNode("svg", {
                          width: "14",
                          height: "14",
                          viewBox: "0 0 16 16",
                          fill: "none"
                        }, [
                          _createElementVNode("path", {
                            d: "M11.5 2.5a1.5 1.5 0 012 2L5 13H3v-2L11.5 2.5z",
                            stroke: "currentColor",
                            "stroke-width": "1.3",
                            fill: "none"
                          })
                        ], -1)
                      ]))], 8, _hoisted_48))
                    : _createCommentVNode("", true)
                ])
              ], 42, _hoisted_37))
            }), 128))
          ]))
        : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "slide-down" }, {
      default: _withCtx(() => [
        (_ctx.editingId && _ctx.editingItem)
          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("span", _hoisted_52, "Editar: " + _toDisplayString(_ctx.editingItem.name), 1),
                  _createElementVNode("button", {
                    class: "fm-close-btn",
                    type: "button",
                    onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args)))
                  }, "✕")
                ]),
                _createElementVNode("form", {
                  onSubmit: _cache[44] || (_cache[44] = _withModifiers(($event: any) => (_ctx.submitEdit(_ctx.editingItem)), ["prevent"]))
                }, [
                  _createElementVNode("div", {
                    class: "fm-drop-zone fm-drop-zone--sm",
                    onClick: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.triggerEditFile && _ctx.triggerEditFile(...args)))
                  }, [
                    _createElementVNode("input", {
                      ref: "editFileInputRef",
                      type: "file",
                      accept: ".pdf,.dwg,image/*",
                      class: "hidden-input",
                      onChange: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_ctx.onEditFilePicked && _ctx.onEditFilePicked(...args)))
                    }, null, 544),
                    _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.editForm.selectedFileName ? '✔' : '↑'), 1),
                    _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.editForm.selectedFileName || 'Substituir arquivo (opcional)'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _cache[82] || (_cache[82] = _createElementVNode("label", null, "Nome", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.editForm.customName) = $event)),
                        type: "text",
                        placeholder: "Nome do arquivo"
                      }, null, 512), [
                        [_vModelText, _ctx.editForm.customName]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _cache[83] || (_cache[83] = _createElementVNode("label", null, "Revisão", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.editForm.revision) = $event))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.revisionOptions, (r) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: `e-${r}`,
                            value: r
                          }, _toDisplayString(r), 9, _hoisted_58))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.editForm.revision]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _cache[84] || (_cache[84] = _createElementVNode("label", null, "Descrição", -1)),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.editForm.description) = $event)),
                      rows: "2",
                      placeholder: "Opcional"
                    }, null, 512), [
                      [_vModelText, _ctx.editForm.description]
                    ])
                  ]),
                  (_ctx.folders.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        _cache[86] || (_cache[86] = _createElementVNode("label", null, "Pasta", -1)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.editForm.folderId) = $event))
                        }, [
                          _cache[85] || (_cache[85] = _createElementVNode("option", { value: "" }, "Raiz", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folders, (f) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: f.id,
                              value: f.id
                            }, _toDisplayString(f.name), 9, _hoisted_61))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.editForm.folderId]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("button", {
                      class: "fm-btn fm-btn-danger fm-btn-sm",
                      type: "button",
                      onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.askDelete(_ctx.editingItem)))
                    }, "Excluir"),
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("button", {
                        class: "fm-btn fm-btn-ghost fm-btn-sm",
                        type: "button",
                        onClick: _cache[43] || (_cache[43] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args)))
                      }, "Cancelar"),
                      _cache[87] || (_cache[87] = _createElementVNode("button", {
                        class: "fm-btn fm-btn-primary fm-btn-sm",
                        type: "submit"
                      }, "Salvar", -1))
                    ])
                  ]),
                  (_ctx.formError)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_64, _toDisplayString(_ctx.formError), 1))
                    : _createCommentVNode("", true)
                ], 32)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "viewer-fade" }, {
        default: _withCtx(() => [
          (_ctx.renamingFolder)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "fm-viewer-overlay",
                onClick: _cache[51] || (_cache[51] = _withModifiers(($event: any) => (_ctx.renamingFolder = null), ["self"]))
              }, [
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, [
                    _cache[88] || (_cache[88] = _createElementVNode("span", { class: "fm-panel-title" }, "Renomear pasta", -1)),
                    _createElementVNode("button", {
                      class: "fm-close-btn",
                      onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.renamingFolder = null))
                    }, "✕")
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    ref: "renameInputRef",
                    "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.renameFolderName) = $event)),
                    class: "fm-folder-input",
                    type: "text",
                    placeholder: "Novo nome",
                    onKeydown: [
                      _cache[47] || (_cache[47] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submitRenameFolder && _ctx.submitRenameFolder(...args)), ["enter"])),
                      _cache[48] || (_cache[48] = _withKeys(($event: any) => (_ctx.renamingFolder = null), ["esc"]))
                    ]
                  }, null, 544), [
                    [_vModelText, _ctx.renameFolderName]
                  ]),
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("button", {
                      class: "fm-btn fm-btn-ghost fm-btn-sm",
                      onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.renamingFolder = null))
                    }, "Cancelar"),
                    _createElementVNode("button", {
                      class: "fm-btn fm-btn-primary fm-btn-sm",
                      onClick: _cache[50] || (_cache[50] = 
//@ts-ignore
(...args) => (_ctx.submitRenameFolder && _ctx.submitRenameFolder(...args)))
                    }, "Salvar")
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "viewer-fade" }, {
        default: _withCtx(() => [
          (_ctx.showMoveModal)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "fm-viewer-overlay",
                onClick: _cache[56] || (_cache[56] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeMoveModal && _ctx.closeMoveModal(...args)), ["self"]))
              }, [
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("span", _hoisted_70, "Mover " + _toDisplayString(_ctx.selectedFiles.length) + " arquivo" + _toDisplayString(_ctx.selectedFiles.length !== 1 ? 's' : ''), 1),
                    _createElementVNode("button", {
                      class: "fm-close-btn",
                      onClick: _cache[52] || (_cache[52] = 
//@ts-ignore
(...args) => (_ctx.closeMoveModal && _ctx.closeMoveModal(...args)))
                    }, "âœ•")
                  ]),
                  _createElementVNode("div", _hoisted_71, [
                    _cache[90] || (_cache[90] = _createElementVNode("label", null, "Destino", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.moveTargetFolderId) = $event))
                    }, [
                      _cache[89] || (_cache[89] = _createElementVNode("option", { value: "" }, "Raiz", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folders, (f) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: `move-${f.id}`,
                          value: f.id
                        }, _toDisplayString(f.name), 9, _hoisted_72))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.moveTargetFolderId]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("button", {
                      class: "fm-btn fm-btn-ghost fm-btn-sm",
                      onClick: _cache[54] || (_cache[54] = 
//@ts-ignore
(...args) => (_ctx.closeMoveModal && _ctx.closeMoveModal(...args)))
                    }, "Cancelar"),
                    _createElementVNode("button", {
                      class: "fm-btn fm-btn-primary fm-btn-sm",
                      onClick: _cache[55] || (_cache[55] = 
//@ts-ignore
(...args) => (_ctx.submitMoveSelected && _ctx.submitMoveSelected(...args))),
                      disabled: _ctx.bulkActionLoading
                    }, "Mover", 8, _hoisted_74)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "viewer-fade" }, {
        default: _withCtx(() => [
          (_ctx.showRenameSelectionModal)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "fm-viewer-overlay",
                onClick: _cache[63] || (_cache[63] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeRenameSelection && _ctx.closeRenameSelection(...args)), ["self"]))
              }, [
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("div", _hoisted_76, [
                    _cache[91] || (_cache[91] = _createElementVNode("span", { class: "fm-panel-title" }, "Renomear arquivo", -1)),
                    _createElementVNode("button", {
                      class: "fm-close-btn",
                      onClick: _cache[57] || (_cache[57] = 
//@ts-ignore
(...args) => (_ctx.closeRenameSelection && _ctx.closeRenameSelection(...args)))
                    }, "âœ•")
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    ref: "renameSelectionInputRef",
                    "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.renameSelectionName) = $event)),
                    class: "fm-folder-input",
                    type: "text",
                    placeholder: "Novo nome do arquivo",
                    onKeydown: [
                      _cache[59] || (_cache[59] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submitRenameSelected && _ctx.submitRenameSelected(...args)), ["enter"])),
                      _cache[60] || (_cache[60] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeRenameSelection && _ctx.closeRenameSelection(...args)), ["esc"]))
                    ]
                  }, null, 544), [
                    [_vModelText, _ctx.renameSelectionName]
                  ]),
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("button", {
                      class: "fm-btn fm-btn-ghost fm-btn-sm",
                      onClick: _cache[61] || (_cache[61] = 
//@ts-ignore
(...args) => (_ctx.closeRenameSelection && _ctx.closeRenameSelection(...args)))
                    }, "Cancelar"),
                    _createElementVNode("button", {
                      class: "fm-btn fm-btn-primary fm-btn-sm",
                      onClick: _cache[62] || (_cache[62] = 
//@ts-ignore
(...args) => (_ctx.submitRenameSelected && _ctx.submitRenameSelected(...args))),
                      disabled: _ctx.bulkActionLoading
                    }, "Salvar", 8, _hoisted_78)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "viewer-fade" }, {
        default: _withCtx(() => [
          (_ctx.viewerFile)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "fm-viewer-overlay",
                onClick: _cache[66] || (_cache[66] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeViewer && _ctx.closeViewer(...args)), ["self"]))
              }, [
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("div", _hoisted_80, [
                    _createElementVNode("div", _hoisted_81, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["fm-file-icon fm-file-icon-sm", `fm-icon-${_ctx.viewerFile.extension.toLowerCase()}`])
                      }, [
                        _createElementVNode("span", _hoisted_82, _toDisplayString(_ctx.viewerFile.extension.toUpperCase()), 1)
                      ], 2),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_83, _toDisplayString(_ctx.viewerFile.name), 1),
                        _createElementVNode("div", _hoisted_84, _toDisplayString(_ctx.viewerFile.extension.toUpperCase()) + " · " + _toDisplayString(_ctx.viewerFile.revision || 'R0') + _toDisplayString(_ctx.viewerFile.description ? ' · ' + _ctx.viewerFile.description : ''), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_85, [
                      (_ctx.accessMode === 'edit')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "fm-btn fm-btn-ghost fm-btn-sm",
                            type: "button",
                            onClick: _cache[64] || (_cache[64] = 
//@ts-ignore
(...args) => (_ctx.openEditFromViewer && _ctx.openEditFromViewer(...args)))
                          }, "Editar"))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        class: "fm-viewer-close",
                        type: "button",
                        onClick: _cache[65] || (_cache[65] = 
//@ts-ignore
(...args) => (_ctx.closeViewer && _ctx.closeViewer(...args)))
                      }, "✕")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_86, [
                    (_ctx.viewerFile.extension === 'pdf')
                      ? (_openBlock(), _createElementBlock("iframe", {
                          key: 0,
                          class: "fm-iframe",
                          src: _ctx.viewerFile.url ? _ctx.$resolveUrl(_ctx.viewerFile.url) : `data:${_ctx.viewerFile.mimeType};base64,${_ctx.viewerFile.contentBase64}`
                        }, null, 8, _hoisted_87))
                      : (_ctx.viewerFile.extension === 'dwg')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_88, [...(_cache[92] || (_cache[92] = [
                            _createElementVNode("div", { class: "fm-dwg-big" }, "📐", -1),
                            _createElementVNode("p", null, "Arquivo DWG", -1),
                            _createElementVNode("p", { class: "fm-viewer-meta" }, "Visualização DWG não disponível no navegador.", -1)
                          ]))]))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 2,
                            class: "fm-img-viewer",
                            src: _ctx.viewerFile.url ? _ctx.$resolveUrl(_ctx.viewerFile.url) : `data:${_ctx.viewerFile.mimeType};base64,${_ctx.viewerFile.contentBase64}`,
                            alt: "preview"
                          }, null, 8, _hoisted_89))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])),
    _createVNode(_component_ConfirmDeleteModal, {
      open: _ctx.confirmOpen,
      label: _ctx.confirmLabel,
      onConfirm: _ctx.confirmDelete,
      onCancel: _ctx.cancelDelete
    }, null, 8, ["open", "label", "onConfirm", "onCancel"])
  ]))
}